<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black2">
      <img src="/img/genesis/img-bg.png" width="100%" />
      <div class="bg_bonus-area"></div>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        "
      >
        <img
          src="/img/genesis/deco-light.png"
          style="
            position: relative;
            margin-top: 166px;
            margin-left: calc(50% - 156px);
          "
        />
        <div class="DRAGO-GENESIS-SALE">DRAGO GENESIS SALE</div>
        <div class="DRAGO-GENESIS-SALE-DESC">
          Welcome to the Drago Genesis!<br />
          Your one and only chance to adopt genesis Dragos
        </div>
        <div
          style="
            position: relative;
            width: 1240px;
            height: 1630px;
            margin-top: 80px;
            margin-left: calc(50% - 620px);
          "
        >
          <div
            style="
              position: absolute;
              width: 100%;
              height: 130px;
              left: 0px;
              top: 0px;
            "
          >
            <div class="sale_head_bg">
              <img
                v-if="
                  currentStage == 0 ||
                  currentStage == 2 ||
                  currentStage == 3 ||
                  currentStage == 98 ||
                  currentStage == 99
                "
                src="/img/genesis/arr.png"
                class="arr"
                style="left: 421px"
              />
              <img
                v-if="
                  currentStage == 0 ||
                  currentStage == 1 ||
                  currentStage == 3 ||
                  currentStage == 98 ||
                  currentStage == 99
                "
                src="/img/genesis/arr.png"
                class="arr"
              />
              <img
                v-if="currentStage == 1"
                src="/img/genesis/whitelist-on-tab.png"
                class="--whitelist_on_tab"
              />
              <img
                v-if="currentStage == 2"
                src="/img/genesis/whitelist-on-tab.png"
                class="--whitelist_on_tab"
                style="left: 547px"
              />
              <img
                v-if="currentStage == 3"
                src="/img/genesis/public-on-tab.png"
                style="position: absolute; right: 0px"
              />
              <div class="Whitelist-Phase" v-if="currentStage == 1">
                Whitelist Phase
              </div>
              <div class="Whitelist-Phase" style="color: #8b4ede" v-else>
                Whitelist Phase
              </div>
              <div
                class="Whitelist-Phase-Remaining-Time"
                v-if="currentStage == 1"
              >
                Remaining Time
                <span style="margin-left: 20px">{{ stagesTime[0] }}</span>
              </div>
              <div
                class="Whitelist-Phase-Remaining-Time"
                style="color: #8b4ede"
                v-else
              >
                Remaining Time
                <span style="margin-left: 20px">{{ stagesTime[0] }}</span>
              </div>
              <div
                class="Guild-Phase"
                style="color: #fff"
                v-if="currentStage == 2"
              >
                Guild Phase
              </div>
              <div class="Guild-Phase" v-else>Guild Phase</div>
              <div
                class="Guild-Phase-Remaining-Time"
                style="color: #fff"
                v-if="currentStage == 2"
              >
                Remaining Time
                <span style="margin-left: 20px">{{ stagesTime[1] }}</span>
              </div>
              <div class="Guild-Phase-Remaining-Time" v-else>
                Remaining Time
                <span style="margin-left: 20px">{{ stagesTime[1] }}</span>
              </div>
              <div
                class="Public-Phase"
                style="color: #fff"
                v-if="currentStage == 3"
              >
                Public Phase
              </div>
              <div class="Public-Phase" v-else>Public Phase</div>
              <div
                class="Public-Phase-Remaining-Time"
                style="color: #fff"
                v-if="currentStage == 3"
              >
                Remaining Time
                <span style="margin-left: 20px">{{ stagesTime[2] }}</span>
              </div>
              <div class="Public-Phase-Remaining-Time" v-else>
                Remaining Time
                <span style="margin-left: 20px">{{ stagesTime[2] }}</span>
              </div>
            </div>
            <div class="bg-sale-area">
              <img
                src="img/genesis/img-deco.png"
                class="--img_deco"
                style="position: absolute; left: 60px; top: 97px"
              />
              <img
                src="img/genesis/img-deco.png"
                class="--img_deco"
                style="position: absolute; right: 60px; top: 97px"
              />
              <div
                class="-line"
                style="position: absolute; left: 90px; top: 103px"
              ></div>
              <div
                class="-line"
                style="position: absolute; right: 90px; top: 103px"
              ></div>
              <div
                style="
                  position: absolute;
                  left: calc(50% - 250px);
                  top: 88px;
                  width: 500px;
                  height: 29px;
                  font-family: Poppins;
                  font-size: 28px;
                  font-weight: 500;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.14;
                  letter-spacing: normal;
                  text-align: center;
                  color: #000;
                "
              >
                Select the Drago to breed
              </div>
              <div
                style="
                  position: absolute;
                  left: 60px;
                  top: 200px;
                  width: 1120px;
                  height: 640px;
                "
              >
                <div
                  v-for="(drago, index) in dragos"
                  v-bind:key="index"
                  style="position: absolute; width: 200px; height: 300px"
                  v-bind:style="{ top: getTop(index), left: getLeft(index) }"
                >
                  <div
                    v-if="drago.count > 0"
                    style="position: absolute; left: 0px; top: 0px"
                  >
                    <div
                      class="bg-drago"
                      v-if="select_ids.includes(drago.id) == false"
                    ></div>
                    <div
                      class="frame-drago-select"
                      v-if="select_ids.includes(drago.id) == true"
                    ></div>
                    <img
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 200px;
                        height: 200px;
                      "
                      v-bind:src="drago.asset"
                      width="200px"
                      height="200px"
                    />
                    <div v-if="drago.id != hover_id">
                      <div
                        v-if="select_ids.includes(drago.id) == true"
                        class="bg-select-2"
                        style="position: absolute; left: 40px; top: 80px"
                      ></div>
                      <div
                        v-if="select_ids.includes(drago.id) == true"
                        style="
                          position: absolute;
                          left: 46px;
                          top: 86px;
                          width: 28px;
                          height: 28px;
                          padding: 2px 6px;
                          border-radius: 14px;
                          border: solid 0 #000;
                          background-color: #fff;
                        "
                      >
                        <img src="/img/genesis/icon-check-on.png" />
                      </div>
                      <div
                        v-if="select_ids.includes(drago.id) == true"
                        style="
                          position: absolute;
                          left: 92px;
                          top: 90px;
                          font-family: Poppins;
                          font-size: 14px;
                          font-weight: 600;
                          font-stretch: normal;
                          font-style: normal;
                          line-height: normal;
                          letter-spacing: normal;
                          text-align: left;
                          color: #fff;
                        "
                      >
                        Select
                      </div>
                    </div>
                    <div
                      v-if="drago.id == hover_id"
                      style="position: absolute; left: 0px; top: 0px"
                    >
                      <div class="bg-dim"></div>
                      <div
                        v-if="select_ids.includes(drago.id) == false"
                        class="bg-select-1"
                        style="position: absolute; left: 40px; top: 80px"
                      ></div>
                      <div
                        v-if="select_ids.includes(drago.id) == false"
                        style="
                          position: absolute;
                          left: 46px;
                          top: 86px;
                          width: 28px;
                          height: 28px;
                          padding: 2px 6px;
                          border-radius: 14px;
                          border: solid 0 #000;
                          background-color: #fff;
                        "
                      >
                        <img src="/img/genesis/icon-check-off.png" />
                      </div>
                      <div
                        v-if="select_ids.includes(drago.id) == false"
                        style="
                          position: absolute;
                          left: 92px;
                          top: 90px;
                          font-family: Poppins;
                          font-size: 14px;
                          font-weight: 600;
                          font-stretch: normal;
                          font-style: normal;
                          line-height: normal;
                          letter-spacing: normal;
                          text-align: left;
                          color: #fff;
                        "
                      >
                        Select
                      </div>
                      <div
                        v-if="select_ids.includes(drago.id) == true"
                        class="bg-select-2"
                        style="position: absolute; left: 40px; top: 80px"
                      ></div>
                      <div
                        v-if="select_ids.includes(drago.id) == true"
                        style="
                          position: absolute;
                          left: 46px;
                          top: 86px;
                          width: 28px;
                          height: 28px;
                          padding: 2px 6px;
                          border-radius: 14px;
                          border: solid 0 #000;
                          background-color: #fff;
                        "
                      >
                        <img src="/img/genesis/icon-check-off.png" />
                      </div>
                      <div
                        v-if="select_ids.includes(drago.id) == true"
                        style="
                          position: absolute;
                          left: 92px;
                          top: 90px;
                          font-family: Poppins;
                          font-size: 14px;
                          font-weight: 600;
                          font-stretch: normal;
                          font-style: normal;
                          line-height: normal;
                          letter-spacing: normal;
                          text-align: left;
                          color: #fff;
                        "
                      >
                        Select
                      </div>
                    </div>
                    <div
                      v-if="index < 5"
                      style="
                        position: absolute;
                        top: 220px;
                        left: 0px;
                        width: 200px;
                        height: 15px;
                      "
                      class="legendary-text"
                    >
                      <img src="/img/genesis/line-legendary.png" />
                      {{ drago.name }}
                      <img src="/img/genesis/line-legendary.png" />
                    </div>
                    <div
                      v-if="index >= 5"
                      style="
                        position: absolute;
                        top: 220px;
                        left: 0px;
                        width: 200px;
                        height: 15px;
                      "
                      class="normal-text"
                    >
                      <img src="/img/genesis/line-normal.png" />
                      {{ drago.name }}
                      <img src="/img/genesis/line-normal.png" />
                    </div>
                    <div
                      style="
                        position: absolute;
                        top: 255px;
                        left: 18px;
                        font-family: Poppins;
                        font-size: 14px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.71;
                        letter-spacing: normal;
                        text-align: left;
                        color: #b6bbc8;
                      "
                    >
                      Breed Cost
                    </div>
                    <div
                      style="
                        position: absolute;
                        top: 255px;
                        left: 125px;
                        font-family: Poppins;
                        font-size: 14px;
                        font-weight: 800;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.71;
                        letter-spacing: normal;
                        text-align: left;
                        color: #4541ff;
                      "
                    >
                      {{ drago.cost | comma }} LOKA
                    </div>
                    <div
                      style="
                        position: absolute;
                        top: 280px;
                        left: 18px;
                        font-family: Poppins;
                        font-size: 14px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.71;
                        letter-spacing: normal;
                        text-align: left;
                        color: #b6bbc8;
                      "
                    >
                      Remain Count
                    </div>
                    <div
                      style="
                        position: absolute;
                        top: 280px;
                        left: 125px;
                        font-family: Poppins;
                        font-size: 14px;
                        font-weight: 800;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.71;
                        letter-spacing: normal;
                        text-align: left;
                        color: #4541ff;
                      "
                    >
                      {{ drago.count | comma }}
                    </div>
                    <div
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 200px;
                        height: 200px;
                        cursor: pointer;
                      "
                      v-on:mouseover="onMouseOver(drago.id)"
                      v-on:mouseout="onMouseOut(drago.id)"
                      v-on:click="onMouseClick(drago.id)"
                    ></div>
                  </div>
                  <div v-else style="position: absolute; left: 0px; top: 0px">
                    <div class="bg-drago"></div>
                    <img
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 200px;
                        height: 200px;
                      "
                      v-bind:src="drago.asset"
                      width="200px"
                      height="200px"
                    />
                    <div style="position: absolute; left: 0px; top: 0px">
                      <div class="bg-dim-soldout"></div>
                      <div
                        style="
                          position: absolute;
                          left: 0px;
                          top: 65px;
                          width: 100%;
                          font-family: Poppins;
                          font-size: 40px;
                          font-weight: 600;
                          font-stretch: normal;
                          font-style: normal;
                          line-height: 1;
                          letter-spacing: normal;
                          text-align: center;
                          color: #fff;
                        "
                      >
                        SOLD<br />OUT
                      </div>
                    </div>
                    <div
                      v-if="index < 5"
                      style="
                        position: absolute;
                        top: 220px;
                        left: 0px;
                        width: 200px;
                        height: 15px;
                      "
                      class="legendary-text"
                    >
                      {{ drago.name }}
                    </div>
                    <div
                      v-if="index >= 5"
                      style="
                        position: absolute;
                        top: 220px;
                        left: 0px;
                        width: 200px;
                        height: 15px;
                      "
                      class="normal-text"
                    >
                      {{ drago.name }}
                    </div>
                    <div
                      style="
                        position: absolute;
                        top: 260px;
                        left: 0px;
                        width: 200px;
                        height: 15px;
                      "
                      class="soldout-text"
                    >
                      Sold out
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-sale-bottom-area">
              <!-- <img
                src="/img/genesis/icon-bl.png"
                style="position: absolute; left: 416px; top: 180px"
              />
              <span
                style="position: absolute; left: 440px; top: 164px"
                class="Cost"
                >Balance</span
              >
              <span
                style="position: absolute; left: 673px; top: 164px"
                class="-LOKA"
                >{{ balance | comma }} LOKA</span
              >

              <img
                src="/img/genesis/icon-bl.png"
                style="position: absolute; left: 416px; top: 220px"
              />
              <span
                style="position: absolute; left: 440px; top: 204px"
                class="Cost"
                >Cost</span
              >
              <span
                style="position: absolute; left: 673px; top: 204px"
                class="-LOKA"
                >{{ getCost() | comma }} LOKA</span
              >

              <img
                src="/img/genesis/icon-bl.png"
                style="position: absolute; left: 416px; top: 260px"
              />
              <span
                style="position: absolute; left: 440px; top: 244px"
                class="Cost"
                >Guarantee</span
              >
              <span
                style="position: absolute; left: 673px; top: 244px"
                class="-LOKA"
                >{{ getGuarantee() }}</span
              >

              <img
                src="/img/genesis/icon-bl.png"
                style="position: absolute; left: 416px; top: 300px"
              />
              <span
                style="position: absolute; left: 440px; top: 284px"
                class="Cost"
                >Count Remaining</span
              >
              <span
                style="position: absolute; left: 673px; top: 284px"
                class="-LOKA"
                >{{ remainCount | comma }}</span
              > -->

              <div
                v-if="currentStage != 2 && currentStage != 98"
                class="--btn-disabled"
                style="position: absolute; left: 320px; top: 363px"
              >
                <div
                  v-if="currentStage == 1"
                  class="--btn_line"
                  style="
                    position: absolute;
                    left: 8px;
                    top: 9px;
                    font-family: Poppins;
                    font-size: 20px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.2;
                    letter-spacing: normal;
                    text-align: center;
                    padding-top: 29px;
                    color: #fff;
                  "
                >
                  BREED (remaining: {{ remainBreedCount }})
                </div>
                <div
                  v-else
                  class="--btn_line"
                  style="
                    position: absolute;
                    left: 8px;
                    top: 9px;
                    font-family: Poppins;
                    font-size: 20px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.2;
                    letter-spacing: normal;
                    text-align: center;
                    padding-top: 29px;
                    color: #fff;
                  "
                >
                  SALE ENDED
                </div>
              </div>
              <div
                v-if="currentStage == 2 && remainBreedCount > 0"
                style="
                  position: absolute;
                  left: 320px;
                  top: 363px;
                  width: 600px;
                  height: 100px;
                "
              >
                <div
                  style="
                    position: absolute;
                    left: 0px;
                    border: solid 0 #fff;
                    background-color: #3920d7;
                    cursor: pointer;
                    top: 0px;
                    width: 380px;
                    height: 100px;
                  "
                  @click="breed()"
                >
                  <div
                    class="--btn_line"
                    style="
                      position: absolute;
                      width: 364px;
                      left: 8px;
                      top: 9px;
                      font-family: Poppins;
                      font-size: 20px;
                      font-weight: 600;
                      font-stretch: normal;
                      font-style: normal;
                      line-height: 1.2;
                      letter-spacing: normal;
                      text-align: center;
                      padding-top: 29px;
                      color: #fff;
                    "
                  >
                    BREED (remaining: {{ remainBreedCount }})
                  </div>
                </div>
                <div
                  style="
                    position: absolute;
                    left: 400px;
                    border: solid 0 #fff;
                    background-color: #6126fa;
                    cursor: pointer;
                    top: 0px;
                    width: 200px;
                    height: 100px;
                  "
                  @click="batchBreed()"
                >
                  <div
                    class="--btn_line"
                    style="
                      position: absolute;
                      width: 184px;
                      left: 8px;
                      top: 9px;
                      font-family: Poppins;
                      font-size: 20px;
                      font-weight: 600;
                      font-stretch: normal;
                      font-style: normal;
                      line-height: 1.2;
                      letter-spacing: normal;
                      text-align: center;
                      padding-top: 29px;
                      color: #fff;
                      border: solid 1px #723bff;
                    "
                  >
                    BATCH BREED
                  </div>
                </div>
              </div>
              <div
                v-if="currentStage == 2 && remainBreedCount == 0"
                style="
                  position: absolute;
                  left: 320px;
                  top: 363px;
                  width: 600px;
                  height: 100px;
                "
              >
                <div
                  style="
                    position: absolute;
                    left: 0px;
                    border: solid 0 #fff;
                    background-color: #3920d7;
                    cursor: pointer;
                    top: 0px;
                    width: 600px;
                    height: 100px;
                  "
                  @click="breed()"
                >
                  <div
                    class="--btn_line"
                    style="
                      position: absolute;
                      width: 564px;
                      left: 8px;
                      top: 9px;
                      font-family: Poppins;
                      font-size: 20px;
                      font-weight: 600;
                      font-stretch: normal;
                      font-style: normal;
                      line-height: 1.2;
                      letter-spacing: normal;
                      text-align: center;
                      padding-top: 29px;
                      color: #fff;
                    "
                  >
                    BREED (remaining: {{ remainBreedCount }})
                  </div>
                </div>
              </div>
              <div
                v-if="currentStage == 98"
                style="
                  position: absolute;
                  left: 320px;
                  top: 363px;
                  width: 600px;
                  height: 100px;
                "
              >
                <div
                  style="
                    position: absolute;
                    left: 0px;
                    border: solid 0 #fff;
                    background-color: #3920d7;
                    top: 0px;
                    width: 600px;
                    height: 100px;
                  "
                >
                  <div
                    class="--btn_line"
                    style="
                      position: absolute;
                      width: 564px;
                      left: 8px;
                      top: 9px;
                      font-family: Poppins;
                      font-size: 20px;
                      font-weight: 600;
                      font-stretch: normal;
                      font-style: normal;
                      line-height: 1.2;
                      letter-spacing: normal;
                      text-align: center;
                      padding-top: 29px;
                      color: #fff;
                    "
                  >
                    Please wait for the sale preparation
                  </div>
                </div>
              </div>
            </div>
            <div style="position: absolute; left: 320px; top: 1070px">
              <img
                src="/img/genesis/blank-drago.png"
                width="280px"
                height="280px"
              />
              <img
                v-if="select_ids[0] == -1"
                src="/img/genesis/select-area-drago.png"
                width="128px"
                height="103px"
                style="position: absolute; left: 76px; top: 88px"
              />
              <img
                v-if="select_ids[0] != -1"
                v-bind:src="dragos[select_ids[0] - 1].asset_280"
                width="280px"
                height="280px"
                style="position: absolute; left: 0px; top: 0px"
              />
            </div>
            <div style="position: absolute; right: 320px; top: 1070px">
              <img
                src="/img/genesis/blank-drago.png"
                width="280px"
                height="280px"
              />
              <img
                v-if="select_ids[1] == -1"
                src="/img/genesis/select-area-drago.png"
                width="128px"
                height="103px"
                style="position: absolute; left: 76px; top: 88px"
              />
              <img
                v-if="select_ids[1] != -1"
                v-bind:src="dragos[select_ids[1] - 1].asset_280"
                width="280px"
                height="280px"
                style="position: absolute; left: 0px; top: 0px"
              />
            </div>
            <div
              class="circle"
              style="position: absolute; left: calc(50% - 36px); top: 1174px"
            >
              <img
                src="/img/genesis/img-plus.png"
                style="position: absolute; left: 24px; top: 24px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      "
      v-if="
        modals.claim_egg == true ||
        modals.transaction_egg == true ||
        modals.batch_result == true ||
        modals.batchbreed == true ||
        $store.state.account.modals.approval == true
      "
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="modals.claim_egg"
      style="
        position: fixed;
        top: calc((100% - 674px) / 2);
        left: calc((100% - 605px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 674px;
        height: 605px;
        background-image: url('/img/genesis/popup-base.png');
        z-index: 10000;
      "
    >
      <div
        style="
          position: absolute;
          left: calc((100% - 300px) / 2);
          top: calc((100% - 300px) / 2);
          width: 300px;
          height: 300px;
        "
      >
        <img v-bind:src="getEggAsset(breed_token_id)" />
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          left: 17px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickOK()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.transaction_egg"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Breed processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for minting egg...<br /><br />
        It may take up to 20-30 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a
          v-bind:href="`https://etherscan.io/tx/${tx_id}`"
          target="_blank"
          style="color: #000; text-decoration: underline"
          >{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30) }}</a
        >
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="onClickOKMinting()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.batch_result"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Congraturations
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 200px;
          width: 90%;
          height: 200px;
        "
      >
        Batch breeding is completed.<br /><br />
        You can see new eggs in 'My Drago' menu.
      </div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="$store.state.account.modals.approval == true"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Need to approve LOKA
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 120px;
          width: 90%;
          height: 200px;
        "
      >
        You should confirm to approve LOKA.<br />
        Please wait for the transaction to complete.<br /><br />
        It may take up to ~3 minutes depending on the Ethereum network
        situation.<br /><br />
        This approval process is required only once.
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.batchbreed == true"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 400px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 399px;
        background-image: url('/img/genesis/popup-base-batchbeed.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Batch Breed
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 0;
          top: 120px;
          width: 90%;
          height: 200px;
        "
      >
        <div
          style="
            position: absolute;
            left: 57px;
            top: 10px;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 600;
            text-align: left;
            color: #202431;
          "
        >
          BREED COUNT
        </div>
        <input
          type="text"
          v-model="numBatchBreed"
          style="
            width: 200px;
            height: 60px;
            padding-left: 20px;
            padding-right: 20px;
            border-radius: 4px;
            border: solid 1px #dfe5ef;
            text-align: right;
            position: relative;
            left: 50px;
            top: 50px;
            background-color: #fff;
          "
        />
        <div
          style="
            position: absolute;
            left: 370px;
            top: 10px;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 600;
            text-align: left;
            color: #202431;
          "
        >
          COST
        </div>
        <img
          src="/img/genesis/icon-loka.png"
          style="position: absolute; left: 370px; top: 68px"
        />
        <div
          style="
            position: absolute;
            left: 410px;
            top: 70px;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: -0.4px;
            text-align: left;
            color: #080f3a;
          "
        >
          {{batchBreedCost | comma}} LOKA
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="startBatchBreed()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          BATCH BREED
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import config from "../config.js";
import { checkLoka, breedDrago, batchBreedDrago, getNetwork } from "../utils/wallet";

export default {
  name: "genesisSale",
  bodyClass: "genesis-sale-page",
  components: {},
  mounted: async function () {
    setTimeout(() => {
      this.getGenesisDashboard();
    }, 1000);
    this.updateTime();
    setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  filters: {
    comma(val) {
      //return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      return Number(val).toLocaleString('en-US');
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getRemainTime(target) {
      let now = new Date();
      let remainTime = new Date(target).getTime() - now.getTime();
      if (remainTime < 0) {
        remainTime = 0;
      }

      let day = Math.floor(remainTime / (24 * 60 * 60 * 1000));
      remainTime -= day * (24 * 60 * 60 * 1000);
      let hour = Math.floor(remainTime / (60 * 60 * 1000));
      remainTime -= hour * (60 * 60 * 1000);
      let min = Math.floor(remainTime / (60 * 1000));
      remainTime -= min * (60 * 1000);
      let sec = Math.floor(remainTime / 1000);

      if (day == 0) {
        return (
          hour.toString().padStart(2, "0") +
          ":" +
          min.toString().padStart(2, "0") +
          ":" +
          sec.toString().padStart(2, "0")
        );
      }
      return (
        day +
        "d " +
        hour.toString().padStart(2, "0") +
        ":" +
        min.toString().padStart(2, "0") +
        ":" +
        sec.toString().padStart(2, "0")
      );
    },
    closeAllPopup() {
      this.modals.claim_egg = false;
      this.modals.batch_result = false;
      this.modals.transaction_egg = false;
      this.modals.batchbreed = false;
      this.$store.commit("closeModal", "approval");
    },
    closeModal(modal) {
      this.modals[modal] = false;
    },
    openModal(modal) {
      this.closeAllPopup();
      this.modals[modal] = true;
    },
    IsLegend(parents) {
      let numLegends = 0;
      for (let i = 0; i < parents.length; ++i) {
        let id = parents[i];
        if (id <= 5) {
          ++numLegends;
        }
      }
      return numLegends > 0;
    },
    getEggLegendAsset(parents) {
      let numLegends = 0;
      for (let i = 0; i < parents.length; ++i) {
        let id = parents[i];
        if (id <= 5) {
          ++numLegends;
        }
      }
      return `/img/genesis/egg/eff_${numLegends}.png`;
    },
    getEggAsset(id) {
      return `${config.api.egg_url}/${id}`;
    },
    async getGenesisDashboard() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }
      var ret = await axios.post(
        `${config.api.nft_url}/drago/genesis/dashboard`,
        { address: address }
      );
      if (ret.data.result) {
        console.log(ret.data);
        for (let i = 0; i < this.dragos.length; ++i) {
          this.dragos[i].cost = ret.data.cost[i];
          this.dragos[i].count = ret.data.counts[i];
        }
        this.remainCount = ret.data.remain;
        this.remainBreedCount = ret.data.remainBreed;
        this.stages = ret.data.stages;
        this.stages[1].start = new Date(new Date(this.stages[1].start).getTime() + 3 * 60 * 60 * 1000);
        if (
          ret.data.balance != null &&
          ret.data.balance != "0" &&
          ret.data.balance != 0
        ) {
          this.balance =
            parseInt(
              ret.data.balance.substring(0, ret.data.balance.length - 15)
            ) / 1000;
        } else {
          this.balance = 0;
        }
      }
    },
    getTop(index) {
      return Math.floor(index / 5) * 360 + "px";
    },
    getLeft(index) {
      return (index % 5) * 230 + "px";
    },
    onMouseOver(dragoId) {
      this.hover_id = dragoId;
    },
    onMouseOut(dragoId) {
      this.hover_id = -1;
    },
    onMouseClick(dragoId) {
      if (this.select_ids.includes(dragoId)) {
        for (let i = 0; i < this.select_ids.length; ++i) {
          if (this.select_ids[i] == dragoId) {
            this.$set(this.select_ids, i, -1);
          }
        }
      } else {
        for (let i = 0; i < this.select_ids.length; ++i) {
          if (this.select_ids[i] == -1) {
            this.$set(this.select_ids, i, dragoId);
            break;
          }
        }
      }
    },
    async onClickOKMinting() {
      await this.getGenesisDashboard();
      this.closeModal("transaction_egg");
    },
    async onClickOK() {
      await this.getGenesisDashboard();
      this.closeModal("claim_egg");
    },
    getCost() {
      let cost = 0;
      for (let i = 0; i < this.select_ids.length; ++i) {
        if (this.select_ids[i] != -1) {
          cost += this.dragos[this.select_ids[i] - 1].cost;
        }
      }
      return cost;
    },
    getGuarantee() {
      let guarantee = "";
      let numLegends = 0;
      let traits = [0, 0, 0, 0, 0];
      for (let i = 0; i < this.select_ids.length; ++i) {
        if (this.select_ids[i] != -1) {
          if (this.select_ids[i] <= 5) {
            ++numLegends;
          }
          traits[(this.select_ids[i] - 1) % 5] += 2;
        }
      }
      if (numLegends > 0) {
        guarantee = numLegends + " Legendary";
      }

      for (let i = 0; i < 5; ++i) {
        if (traits[i] > 0) {
          if (guarantee != "") {
            guarantee += ", ";
          }
          switch (i) {
            case 0:
              guarantee += traits[i] + " Fire";
              break;
            case 1:
              guarantee += traits[i] + " Aqua";
              break;
            case 2:
              guarantee += traits[i] + " Light";
              break;
            case 3:
              guarantee += traits[i] + " Terra";
              break;
            case 4:
              guarantee += traits[i] + " Dark";
              break;
          }
        }
      }

      if (guarantee == "") {
        return "-";
      }
      return guarantee;
    },
    batchBreed() {
      this.openModal("batchbreed");
    },
    async startBatchBreed() {
      this.closeAllPopup();

      if (this.numBatchBreed <= 0 || this.numBatchBreed > 100) {
        this.$store.commit("alert", `Breed count must be between 1 and 100.`);
        return;
      }

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      if (address == null || address == "") {
        this.$store.commit("alert", "You should connect wallet for breeding.");
        return;
      }

      this.networkId = await getNetwork();
      if (this.networkId != config.network.eth) {
        this.$store.commit(
          "alert",
          "Wrong network. You should change network to Ethereum mainnet."
        );
        return;
      }

      let ret = await axios.post(`${config.api.nft_url}/drago/batchbreed`, {
        num: this.numBatchBreed,
      });
      if (ret.data.result == true) {
        console.log(ret.data.list);

        await checkLoka(this.$store);
        let self = this;

        //
        batchBreedDrago(this.$store, ret.data.list)
          .on("transactionHash", async (txHash) => {
            console.log("transactionHash");
            console.log(txHash);
            self.tx_id = txHash;
            self.openModal("transaction_egg");
          })
          .on("receipt", async (receipt) => {
            console.log("receipt");
            console.log(receipt);
            // let tokenId = parseInt(receipt.logs[3].topics[3], 16);
            // self.breed_token_id = tokenId;
             self.openModal("batch_result");
            //console.log(tokenId)
            // resolve({result: true, data: receipt});
          })
          .on("error", (error) => {
            console.log("error");
            console.log(error);
            alert(error);
          });
      }
    },
    async breed() {
      for (let i = 0; i < this.select_ids.length; ++i) {
        let id = this.select_ids[i];
        if (id < 1 || id > 10) {
          this.$store.commit(
            "alert",
            "For Breeding, you must choose two dragos."
          );
          return;
        }
      }
      console.log(this.select_ids);

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      if (address == null || address == "") {
        this.$store.commit("alert", "You should connect wallet for breeding.");
        return;
      }

      this.networkId = await getNetwork();
      if (this.networkId != config.network.eth) {
        this.$store.commit(
          "alert",
          "Wrong network. You should change network to Ethereum mainnet."
        );
        return;
      }

      var ret = await axios.post(`${config.api.nft_url}/drago/genesis/breed`, {
        address: address,
        ids: this.select_ids,
      });
      if (ret.data.result == false) {
        switch (ret.data.err.code) {
          default:
          case "not_start_sale":
            this.$store.commit("alert", `The sale hasn't started yet.`);
            break;
          case "sale_finished":
            this.$store.commit("alert", `The sale has ended.`);
            break;
        }
        return;
      }

      if (this.remainCount <= 0) {
        this.$store.commit("alert", "There are no breeding counts remaining");
        return;
      }

      if (
        (this.currentStage == 1 || this.currentStage == 2) &&
        this.remainBreedCount == 0
      ) {
        this.$store.commit("alert", "There are no breeding counts remaining");
        return;
      }
      await checkLoka(this.$store);
      let self = this;

      //
      breedDrago(this.$store, this.select_ids)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          console.log(txHash);
          self.tx_id = txHash;
          self.openModal("transaction_egg");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log(receipt);
          let tokenId = parseInt(receipt.logs[3].topics[3], 16);
          self.breed_token_id = tokenId;
          self.openModal("claim_egg");
          // resolve({result: true, data: receipt});
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
          alert(error);
        });
    },
    updateTime() {
      if (this.modals.batchbreed == true) {
        this.batchBreedCost = parseInt(this.numBatchBreed) * 80;
      }

      let now = new Date();

      let prevStage = this.currentStage;

      if (new Date(this.stages[2].end).getTime() < now) {
        this.currentStage = 99;
      } else if (new Date(this.stages[2].start).getTime() < now) {
        this.currentStage = 3;
      } else if (new Date(this.stages[1].start).getTime() < now) {
        this.currentStage = 2;
      } else if (new Date(this.stages[0].end).getTime() < now) {
        this.currentStage = 98;
      } else if (new Date(this.stages[0].start).getTime() < now) {
        this.currentStage = 1;
      } else {
        this.currentStage = 0;
      }

      if (prevStage != this.currentStage) {
        this.getGenesisDashboard();
      }

      switch (this.currentStage) {
        case 0:
          this.$set(
            this.stagesTime,
            0,
            this.getRemainTime(this.stages[0].start)
          );
          this.$set(
            this.stagesTime,
            1,
            this.getRemainTime(this.stages[1].start)
          );
          this.$set(
            this.stagesTime,
            2,
            this.getRemainTime(this.stages[2].start)
          );
          break;
        case 1:
          this.$set(this.stagesTime, 0, this.getRemainTime(this.stages[0].end));
          this.$set(
            this.stagesTime,
            1,
            this.getRemainTime(this.stages[1].start)
          );
          this.$set(
            this.stagesTime,
            2,
            this.getRemainTime(this.stages[2].start)
          );
          break;
        case 2:
          this.$set(this.stagesTime, 0, "Finished");
          this.$set(this.stagesTime, 1, this.getRemainTime(this.stages[1].end));
          this.$set(
            this.stagesTime,
            2,
            this.getRemainTime(this.stages[2].start)
          );
          break;
        case 98:
          this.$set(this.stagesTime, 0, "Finished");
          this.$set(this.stagesTime, 1, this.getRemainTime(this.stages[1].start));
          this.$set(
            this.stagesTime,
            2,
            this.getRemainTime(this.stages[2].start)
          );
          break;
        case 3:
          this.$set(this.stagesTime, 0, "Finished");
          this.$set(this.stagesTime, 1, "Finished");
          this.$set(this.stagesTime, 2, this.getRemainTime(this.stages[2].end));
          break;
        default:
        case 99:
          this.$set(this.stagesTime, 0, "Finished");
          this.$set(this.stagesTime, 1, "Finished");
          this.$set(this.stagesTime, 2, "Finished");
          break;
      }
    },
  },
  watch: {
    "$store.state.account.wallet": async function (val) {
      await this.getGenesisDashboard();
    },
  },
  data() {
    return {
      numBatchBreed: 0,
      batchBreedCost: 0,
      tx_id: "0x000000000000000000000000000000000000000000000000000000000000",
      breed_token_id: 0,
      hover_id: -1,
      select_ids: [-1, -1],
      remainCount: 0,
      remainBreedCount: 0,
      balance: 0,
      networkId: 0,
      modals: {
        claim_egg: false,
        transaction_egg: false,
        batch_result: false,
        batchbreed: false,
      },
      currentStage: 0,
      stages: [
        {
          start: new Date("2022-05-30 00:00:00Z"),
          end: new Date("2022-05-31 00:00:00Z"),
        },
        {
          start: new Date("2022-05-31 03:00:00Z"),
          end: new Date("2022-06-01 00:00:00Z"),
        },
        {
          start: new Date("2022-06-01 00:00:00Z"),
          end: new Date("2022-06-08 00:00:00Z"),
        },
      ],
      stagesTime: ["00:00:00", "00:00:00", "00:00:00"],
      dragos: [
        {
          id: 1,
          name: "Legendary Fire",
          asset: "/img/genesis/legendary01.png",
          asset_280: "/img/genesis/legendary01_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 2,
          name: "Legendary Aqua",
          asset: "/img/genesis/legendary02.png",
          asset_280: "/img/genesis/legendary02_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 3,
          name: "Legendary Light",
          asset: "/img/genesis/legendary03.png",
          asset_280: "/img/genesis/legendary03_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 4,
          name: "Legendary Terra",
          asset: "/img/genesis/legendary04.png",
          asset_280: "/img/genesis/legendary04_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 5,
          name: "Legendary Dark",
          asset: "/img/genesis/legendary05.png",
          asset_280: "/img/genesis/legendary05_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 6,
          name: "Fire",
          asset: "/img/genesis/normal01.png",
          asset_280: "/img/genesis/normal01_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 7,
          name: "Aqua",
          asset: "/img/genesis/normal02.png",
          asset_280: "/img/genesis/normal02_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 8,
          name: "Light",
          asset: "/img/genesis/normal03.png",
          asset_280: "/img/genesis/normal03_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 9,
          name: "Terra",
          asset: "/img/genesis/normal04.png",
          asset_280: "/img/genesis/normal04_280.png",
          cost: 0,
          count: 0,
        },
        {
          id: 10,
          name: "Dark",
          asset: "/img/genesis/normal05.png",
          asset_280: "/img/genesis/normal05_280.png",
          cost: 0,
          count: 0,
        },
      ],
    };
  },
};
</script>
<style>
.page-header {
  max-height: none !important;
}

.bg_bonus-area {
  width: 100%;
  height: 1570px;
  border: solid 0 #000;
  background-color: #04050d;
}

.DRAGO-GENESIS-SALE {
  position: relative;
  width: 800px;
  height: 80px;
  margin-top: 25px;
  margin-left: calc(50% - 400px);
  background-image: linear-gradient(to right, #ff9c00, #f4ff3f),
    linear-gradient(to bottom, #fff600, #fff600);
  font-size: 72px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: -1.8px;
  text-align: center;
  color: #fff600;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.DRAGO-GENESIS-SALE-DESC {
  position: relative;
  margin-top: 40px;
  margin-left: calc(50% - 400px);
  width: 800px;
  height: 54px;
  font-family: Poppins;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.sale_head_bg {
  position: absolute;
  width: 1240px;
  height: 130px;
  top: 0px;
  left: 0px;
  opacity: 0.8;
  border: solid 0 #000;
  background-color: #400fb2;
}

img.--whitelist_on_tab {
  position: absolute;
  left: 134px;
  top: 0px;
  width: 339px;
  height: 130px;
  object-fit: contain;
}

.Whitelist-Phase {
  position: absolute;
  left: 94px;
  top: 30px;
  width: 183px;
  height: 20px;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #fff;
}

.Whitelist-Phase-Remaining-Time {
  width: 300px;
  height: 18px;
  position: absolute;
  top: 70px;
  left: 94px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: -0.4px;
  text-align: left;
  color: #fff;
}

.Guild-Phase {
  position: absolute;
  left: 537px;
  top: 30px;
  width: 183px;
  height: 20px;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #8b4ede;
}

.Guild-Phase-Remaining-Time {
  width: 300px;
  height: 18px;
  position: absolute;
  top: 70px;
  left: 537px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: -0.4px;
  text-align: left;
  color: #8b4ede;
}

.Public-Phase {
  position: absolute;
  left: 952px;
  top: 30px;
  width: 183px;
  height: 20px;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
  color: #8b4ede;
}

.Public-Phase-Remaining-Time {
  width: 300px;
  height: 18px;
  position: absolute;
  top: 70px;
  left: 952px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: -0.4px;
  text-align: left;
  color: #8b4ede;
}

img.arr {
  position: absolute;
  left: 834px;
  top: 20px;
  width: 44px;
  height: 90px;
  object-fit: contain;
  opacity: 0.6;
  mix-blend-mode: soft-light;
}

.bg-sale-area {
  position: absolute;
  top: 130px;
  left: 0px;
  width: 1240px;
  height: 1080px;
  box-shadow: 0px 20px 20px 0 rgba(0, 0, 0, 0.1);
  border: solid 0 #000;
  background-color: #fff;
}

.bg-sale-bottom-area {
  position: absolute;
  top: 1210px;
  left: 0px;
  width: 1240px;
  height: 413px;
  border: solid 0 #000;
  background-image: linear-gradient(to top, #060b29, #20084d);
}

img.--img_deco {
  width: 20px;
  height: 14px;
  object-fit: contain;
}

.-line {
  width: 300px;
  height: 2px;
  border: solid 0 #000;
  background-color: #000;
}

.bg-drago {
  width: 200px;
  height: 200px;
  border-radius: 100px;
  border: solid 0 #000;
  background-color: #e6e7ec;
}

.legendary-text {
  width: 103px;
  height: 15px;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #ff803a;
}

.normal-text {
  width: 103px;
  height: 15px;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #333649;
}

.soldout-text {
  width: 103px;
  height: 15px;
  font-family: Poppins;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: center;
  color: #d0d7e1;
}

img.-blank-drago {
  width: 280px;
  height: 280px;
  object-fit: contain;
}

.circle {
  width: 72px;
  height: 72px;
  border-radius: 36px;
  box-shadow: 0px 10px 10px 0 rgba(80, 36, 222, 0.2);
  border: solid 0 #21243b;
  background-color: #5024de;
}

.Cost {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: -0.4px;
  text-align: left;
  color: #9584fe;
}

.-LOKA {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.63;
  letter-spacing: -0.4px;
  text-align: left;
  color: #fff;
}

.--btn {
  width: 600px;
  height: 100px;
  border: solid 0 #fff;
  background-color: #3920d7;
  cursor: pointer;
}

.--btn-disabled {
  width: 600px;
  height: 100px;
  border: solid 0 #fff;
  background-color: #3920d7;
}

.--btn_line {
  width: 584px;
  height: 84px;
  box-shadow: 0px 2px 2px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px #4d31ff;
}

.bg-dim {
  width: 200px;
  height: 200px;
  opacity: 0.4;
  border-radius: 100px;
  border: solid 0 #000;
  background-color: #000;
}

.bg-dim-soldout {
  width: 200px;
  height: 200px;
  opacity: 0.6;
  border-radius: 100px;
  border: solid 0 #000;
  background-color: #000;
}

.bg-select-1 {
  width: 120px;
  height: 40px;
  opacity: 0.8;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #202431;
}

.bg-select-2 {
  width: 120px;
  height: 40px;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #6713e8;
}

.frame-drago-select {
  width: 200px;
  height: 200px;
  border-radius: 100px;
  box-shadow: 0 0 0 0 #000, inset 0 0 0 0 #000, inset 0 0 0 4px #873cfa;
  background-color: #fff;
}

.popup-btn {
  width: 280px;
  height: 70px;
  border-radius: 2px;
  border: solid 0 #000;
  background-color: #0a1844;
  font-family: Poppins;
  padding-top: 22px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.popup-head-text {
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.popup-content-text {
  font-family: Poppins;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #000;
}

#loading-image {
  height: 80px;
  width: 80px;
  background: url("/img/genesis/loading.png") 0px 0px;
  animation: play 0.8s steps(8) infinite;
}
@keyframes play {
  100% {
    background-position: -640px;
  }
}
</style>
